import {getStandardBoltpattern, isFps} from './common';

(function ($) {
    // init variables
    let ymm_machine_type = $('#machine_type'),
        ymm_year = $('#year'),
        ymm_make = $('#make'),
        ymm_model = $('#model'),
        ymm_trim = $('#trim'),
        ymm_drive = $('#drive'),
        ymm_cab = $('#cab'),
        ymm_cab_wrapper = $('#cab-wrapper'),
        ymm_package = $('#package'),
        ymm_package_wrapper = $('#package-wrapper'),
        ymm_vehicle_type = $('input[name="vehicle_type"]'),
        ymm_suspension = $('#vehicle-suspension'),
        ymm_last_spec = {},
        ymm_resolved_cab = '',
        ymm_resolved_package = '';

    // ymm fields
    ymm_machine_type.change(function () {
        getYears();
    });

    ymm_year.change(function () {
        getMakes();
    });

    ymm_make.change(function () {
        getModels();
    });

    ymm_model.change(function () {
        getTrims();
    });

    ymm_trim.change(function () {
        getDrives();
    });

    ymm_drive.change(function () {
        getVehicleSpec();
    });

    ymm_cab.change(function () {
        getPackages();
    });

    ymm_package.change(function () {
        getBoltpatternFromSpec();
    });

    /**
     * Get years from fitment service
     */
    function getYears() {
        if (isFps()) {
            ymm_year.html("<option value=''>Loading...</option>");
            $.ajax({
                type: "get",
                url: getFitmentURL(),
                success: function (result) {
                    populateSelect2Elements('#year', 'Select Year', result, 'desc');
                }
            });
        }
    }

    /**
     * Get makes from Fitment Service
     */
    function getMakes() {
        let year = ymm_year.val();
        ymm_make.html("<option value=''>Loading...</option>");
        $.ajax({
            type: "get",
            url: getFitmentURL() + '/' + year,
            success: function (result) {
                populateSelect2Elements('#make', 'Select Make', result);
            }
        });
    }

    /**
     * Get models from Fitment Service
     */
    function getModels() {
        let year = ymm_year.val(),
            make = ymm_make.val();
        ymm_model.html("<option value=''>Loading...</option>");
        $.ajax({
            type: "get",
            url: getFitmentURL() + '/' + year + '/' + make,
            success: function (result) {
                populateSelect2Elements('#model', 'Select Model', result);
            }
        });
    }

    /**
     * Get trims from Fitment Service
     */
    function getTrims() {
        let machine_type = ymm_machine_type.val(),
            year = ymm_year.val(),
            make = ymm_make.val(),
            model = ymm_model.val();
        ymm_trim.html("<option value=''>Loading...</option>");
        if (!isFps()) {
            $.ajax({
                type: "get",
                url: api_endpoints['fitment_service'] + '/' + year + '/' + make + '/' + model,
                success: function (result) {
                    let label = 'Trim',
                        data = result.trim;

                    // update vehicle_type field
                    ymm_vehicle_type.val(result.vehicleType.toString().toLowerCase());
                    ymm_trim.parent().find('.label-sm').html(label);
                    populateSelect2Elements('#trim', 'Select ' + label, data);
                    getSuspensionOptions();
                }
            });
        } else {
            ymm_vehicle_type.val(machine_type);
            getSuspensionOptions();
            getBoltpattern();
        }
    }

    /**
     * Get Drive or Trim from Fitment Service
     */
    function getDrives() {
        let machine_type = ymm_machine_type.val(),
            year = ymm_year.val(),
            make = ymm_make.val(),
            model = ymm_model.val();
        ymm_drive.html("<option value=''>Loading...</option>");
        if (!isFps()) {
            $.ajax({
                type: "get",
                url: api_endpoints['fitment_service'] + '/' + year + '/' + make + '/' + model,
                success: function (result) {
                    let label = 'Drive',
                        data = result.drive;

                    // update vehicle_type field
                    ymm_vehicle_type.val(result.vehicleType.toString().toLowerCase());
                    ymm_drive.parent().find('.label-sm').html(label);
                    populateSelect2Elements('#drive', 'Select ' + label, data);

                }
            });
        } else {
            ymm_vehicle_type.val(machine_type);
            getBoltpattern();
        }
    }

    /**
     * Once Drive is selected, fetch the full vehicle spec from the fitment service to determine
     * whether this vehicle needs additional Cab/Package selection before boltpattern can be
     * resolved (multi-chassis vehicles, e.g. dually trucks with Single/Dual Rear Wheel packages).
     */
    function getVehicleSpec() {
        resetCabPackage();

        let year = ymm_year.val(),
            make = ymm_make.val(),
            model = ymm_model.val(),
            trim = ymm_trim.val(),
            drive = ymm_drive.val();

        if (isFps() || !year || !make || !model || !drive) {
            getBoltpattern();
            return;
        }

        $.ajax({
            type: "get",
            url: api_endpoints['fitment_service'] + '/' + year + '/' + make + '/' + model + '/' + trim.replace(/\//g, '~') + '/' + drive,
            success: function (result) {
                ymm_last_spec = result || {};
                let vehicleType = [].concat(ymm_last_spec.vehicleType)[0];
                if (vehicleType) {
                    ymm_vehicle_type.val(vehicleType.toString().toLowerCase());
                }

                if (ymm_last_spec.multiChassis == '1') {
                    getCabs();
                } else if (ymm_last_spec.boltpattern) {
                    applyBoltpatternFromSpec(ymm_last_spec);
                } else {
                    getBoltpattern();
                }
            },
            error: function () {
                getBoltpattern();
            }
        });
    }

    /**
     * Fetch cab/body-style options for a multi-chassis vehicle (e.g. "Crew Cab Pickup"). The Cab
     * dropdown is only shown if there's more than one option to choose from.
     */
    function getCabs() {
        let year = ymm_year.val(),
            make = ymm_make.val(),
            model = ymm_model.val(),
            trim = ymm_trim.val(),
            drive = ymm_drive.val();

        $.ajax({
            type: "get",
            url: api_endpoints['fitment_service'] + '/offsetguide/' + year + '/' + make + '/' + model + '/' + trim.replace(/\//g, '~') + '/' + drive + '/bodies',
            success: function (bodies) {
                if (bodies && bodies.length > 1) {
                    ymm_resolved_cab = '';
                    populateSelect2Elements('#cab', 'Select Cab', bodies);
                    setDropdownVisible(ymm_cab, ymm_cab_wrapper, true);
                } else {
                    ymm_resolved_cab = (bodies && bodies.length === 1) ? bodies[0] : '';
                    setDropdownVisible(ymm_cab, ymm_cab_wrapper, false);
                    getPackages();
                }
            },
            error: function () {
                ymm_resolved_cab = '';
                getPackages();
            }
        });
    }


    function getPackages() {
        let year = ymm_year.val(),
            make = ymm_make.val(),
            model = ymm_model.val(),
            trim = ymm_trim.val(),
            drive = ymm_drive.val(),
            cab = ymm_cab.val() || ymm_resolved_cab,
            url = api_endpoints['fitment_service'] + '/offsetguide/' + year + '/' + make + '/' + model + '/' + trim.replace(/\//g, '~') + '/' + drive + '/packages';

        if (cab) {
            url += '?body=' + encodeURIComponent(cab);
        }

        $.ajax({
            type: "get",
            url: url,
            success: function (packages) {
                if (packages && packages.length > 1) {
                    ymm_resolved_package = '';
                    populateSelect2Elements('#package', 'Select Package', packages);
                    setDropdownVisible(ymm_package, ymm_package_wrapper, true);
                } else {
                    ymm_resolved_package = (packages && packages.length === 1) ? packages[0] : '';
                    setDropdownVisible(ymm_package, ymm_package_wrapper, false);
                    getBoltpatternFromSpec();
                }
            },
            error: function () {
                ymm_resolved_package = '';
                getBoltpatternFromSpec();
            }
        });
    }

    /**
     * Resolve boltpattern for a multi-chassis vehicle once Cab/Package are settled. Re-fetches
     * the full vehicle spec scoped to the chosen Cab/Package (when either was selected) and reads
     * boltpattern straight off it, since that response is already correctly scoped - this avoids
     * guessing whether the legacy single-dimension boltpattern endpoint (see getBoltpattern())
     * accepts trailing Cab/Package segments it was never built to receive.
     */
    function getBoltpatternFromSpec() {
        let year = ymm_year.val(),
            make = ymm_make.val(),
            model = ymm_model.val(),
            trim = ymm_trim.val(),
            drive = ymm_drive.val(),
            cab = ymm_cab.val() || ymm_resolved_cab,
            vehicle_package = ymm_package.val() || ymm_resolved_package;

        if (!cab && !vehicle_package) {
            applyBoltpatternFromSpec(ymm_last_spec);
            return;
        }

        if (!cab && vehicle_package) {
            applyBoltpatternFromSpec(ymm_last_spec);
            return;
        }

        let url = api_endpoints['fitment_service'] + '/' + year + '/' + make + '/' + model + '/' + trim.replace(/\//g, '~') + '/' + drive;
        if (cab) {
            url += '/' + encodeURIComponent(cab);
        }
        if (vehicle_package) {
            url += '/' + encodeURIComponent(vehicle_package);
        }

        $.ajax({
            type: "get",
            url: url,
            success: function (result) {
                // only trust the Cab/Package-scoped response if it actually carries a boltpattern -
                // otherwise keep the last known-good spec so boltpattern doesn't get wiped out by an
                // incomplete/malformed response.
                if (result && result.boltpattern) {
                    ymm_last_spec = result;
                }
                applyBoltpatternFromSpec(ymm_last_spec);
            },
            error: function () {
                applyBoltpatternFromSpec(ymm_last_spec);
            }
        });
    }

    /**
     * Standardize and apply a boltpattern taken from a vehicle spec response.
     */
    function applyBoltpatternFromSpec(spec) {
        if (!spec || !spec.boltpattern) {
            return;
        }
        let boltpattern = getStandardBoltpattern(spec.boltpattern + ' ' + (spec.boltpatternMm || ''), isFps());
        if (boltpattern) {
            $('#boltpattern').val(boltpattern).trigger('change');
        }
    }

    /**
     * Set boltpattern from Fitment Service on a single dimension. Fallback for powersports, and
     * for a vehicle the full trim+drive spec couldn't resolve.
     */
    function getBoltpattern() {
        let vehicle_type = ymm_vehicle_type.val(),
            year = ymm_year.val(),
            make = ymm_make.val(),
            model = ymm_model.val(),
            trim = ymm_trim.val(),
            drive = ymm_drive.val();
        if (isFps()) {
            $.ajax({
                type: "post",
                url: api_endpoints['fps_boltpattern'],
                data: {
                    vehicle_type: vehicle_type,
                    year: year,
                    make: make,
                    model: model
                },
                success: function (result) {
                    $('#boltpattern').val(result.pcd_f).trigger('change')
                }
            });
            return;
        }

        if (!year || !make || !model || (!trim && !drive)) {
            return;
        }

        let dimension = trim
            ? 'trim/' + trim.replace(/\//g, '~')
            : 'drive/' + drive.replace(/\//g, '~');

        $.ajax({
            type: "get",
            url: api_endpoints['fitment_service'] + '/' + year + '/' + make + '/' + model + '/' + dimension,
            success: function (result) {
                applyBoltpatternFromSpec(result);
            }
        });
    }

    /**
     * Show or hide the Cab/Package wrapper column. Hidden fields are reset to a blank
     * placeholder so a leftover selection from a previous vehicle can't be submitted.
     */
    function setDropdownVisible(select, wrapper, visible) {
        if (visible) {
            wrapper.show();
        } else {
            select.html("<option value=''></option>");
            wrapper.hide();
        }
    }

    /**
     * Reset Cab/Package whenever Drive (or anything upstream of it) changes, so a stale
     * selection from a previous vehicle can't linger into the next fitment/boltpattern lookup.
     */
    function resetCabPackage() {
        setDropdownVisible(ymm_cab, ymm_cab_wrapper, false);
        setDropdownVisible(ymm_package, ymm_package_wrapper, false);
        ymm_resolved_cab = '';
        ymm_resolved_package = '';
    }

    /**
     * Get ChassisID from Fitment Service
     */
    function getChassisID() {
        let year = ymm_year.val();
        let make = ymm_make.val();
        let model = ymm_model.val();
        let trim = ymm_trim.val();
        let carTruck = 'trim';

        $.ajax({
            type: "get",
            url: api_endpoints['fitment_service'] + '/' + year + '/' + make + '/' + model + '/' + carTruck + '/' + trim.replace(/\//g, '~'),
            success: function (result) {
                return result.drchassisid;
            }
        });
    }

    /**
     * Set options for suspension depending on vehicle type
     */
    function getSuspensionOptions() {
        $.ajax({
            type: "post",
            url: api_endpoints['suspension_options'],
            data: {
                isFps: isFps(),
                vehicleType: ymm_vehicle_type.val()
            },
            success: function (result) {
                populateSelect2Elements('#vehicle-suspension', 'Select Suspension', result, 'ignore');
            }
        });
    }

    /**
     * Get fitment service URL depending on vendor
     * @returns {string}
     */
    function getFitmentURL() {
        let url = api_endpoints['fitment_service'],
            machine_type = ymm_machine_type.val()
        if (isFps()) {
            url = api_endpoints['fitment_service_fps'] + '/' + machine_type;
        }
        return url;
    }

    /**
     * Populate select2 dropdowns with data from API response
     * @param input dropdown element
     * @param first_option default option
     * @param elements list of key-value elements from API
     * @param sort sorting of options
     */
    function populateSelect2Elements(input, first_option, elements, sort = 'asc') {
        // sort elements
        if (sort !== 'ignore') {
            elements.sort();
        }
        if (sort === 'desc') {
            elements.reverse()
        }

        // placeholder
        $(input).html("<option data-value='' selected='selected' value=''>" + first_option + "</option>");

        // populate select2
        $.each(elements, function (index, element) {
            if(elements.length == 1) {
                $(input).append("<option data-value='" + element + "' selected>" + element + "</option>");
                $(input).trigger('change');
            } else {
                $(input).append("<option data-value='" + element + "'>" + element + "</option>");
            }
        });
    }
})(jQuery);
